import { render, staticRenderFns } from "./ExpandableList.vue?vue&type=template&id=3edfdddd&scoped=true"
import script from "./ExpandableList.vue?vue&type=script&lang=js"
export * from "./ExpandableList.vue?vue&type=script&lang=js"
import style0 from "./ExpandableList.vue?vue&type=style&index=0&id=3edfdddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edfdddd",
  null
  
)

export default component.exports